// extracted by mini-css-extract-plugin
export default {"container":"src-pages-SalesChannelContentEditor-SalesChannelEditorHomepage-TopConfigs-css__container--rWn69"};